import { Component, ElementRef, ViewContainerRef, ValueProvider, Renderer2, Injector, ChangeDetectionStrategy, forwardRef, ContentChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ComponentBase, IComponentBase, applyMixins, ComponentMixins, PropertyCollectionInfo, FormBase, setValue } from '@syncfusion/ej2-angular-base';
import { MultiSelect } from '@syncfusion/ej2-dropdowns';
import { Template } from '@syncfusion/ej2-angular-base';


export const /** @type {?} */ inputs: string[] = ['actionFailureTemplate','allowCustomValue','allowFiltering','changeOnBlur','closePopupOnSelect','cssClass','dataSource','delimiterChar','enableGroupCheckBox','enableHtmlSanitizer','enablePersistence','enableRtl','enableSelectionOrder','enabled','fields','filterBarPlaceholder','filterType','floatLabelType','footerTemplate','groupTemplate','headerTemplate','hideSelectedItem','htmlAttributes','ignoreAccent','ignoreCase','itemTemplate','locale','maximumSelectionLength','mode','noRecordsTemplate','openOnClick','placeholder','popupHeight','popupWidth','query','readonly','selectAllText','showClearButton','showDropDownIcon','showSelectAll','sortOrder','text','unSelectAllText','value','valueTemplate','width','zIndex'];
export const /** @type {?} */ outputs: string[] = ['actionBegin','actionComplete','actionFailure','beforeOpen','blur','change','chipSelection','close','created','customValueSelection','dataBound','destroyed','filtering','focus','open','removed','removing','select','selectedAll','tagging','valueChange'];
export const /** @type {?} */ twoWays: string[] = ['value'];
/**
 * The MultiSelect allows the user to pick a values from the predefined list of values.
 * ```html
 * <ejs-multiselect></ejs-multiselect>
 * ```
 */
@ComponentMixins([ComponentBase, FormBase])
export class MultiSelectComponent extends MultiSelect implements IComponentBase {
public formCompContext : any;
public formContext : any;
public tagObjects: any;
public valueChange: any;
/**
 * Accepts the template design and assigns it to the footer container of the popup list. 
 * > For more details about the available template options refer to [`Template`](../../multi-select/templates) documentation.
 * \@default null
 */
@Template()
    public footerTemplate: any;
/**
 * Accepts the template design and assigns it to the header container of the popup list. 
 * > For more details about the available template options refer to [`Template`](../../multi-select/templates) documentation.
 * \@default null
 */
@Template()
    public headerTemplate: any;
/**
 * Accepts the template design and assigns it to the selected list item in the input element of the component. 
 * For more details about the available template options refer to 
 * [`Template`](../../multi-select/templates) documentation.
 * 
 * We have built-in `template engine`
 * which provides options to compile template string into a executable function.
 * For EX: We have expression evolution as like ES6 expression string literals.     
 * \@default null
 */
@Template()
    public valueTemplate: any;
/**
 * Accepts the template design and assigns it to each list item present in the popup. 
 * > For more details about the available template options refer to [`Template`](../../multi-select/templates) documentation.
 * 
 * We have built-in `template engine`
 * which provides options to compile template string into a executable function.
 * For EX: We have expression evolution as like ES6 expression string literals.     
 * \@default null
 */
@Template()
    public itemTemplate: any;
    
    @Template('No records found')
public noRecordsTemplate: any;
    
    @Template('Request failed')
public actionFailureTemplate: any;
private skipFromEvent:boolean = true;
/**
 * @param {?} ngEle
 * @param {?} srenderer
 * @param {?} viewContainerRef
 * @param {?} injector
 */
constructor(private ngEle: ElementRef,
private srenderer: Renderer2,
private viewContainerRef:ViewContainerRef,
private injector: Injector) {
        super();
        this.element = this.ngEle.nativeElement;
        this.injectedModules = this.injectedModules || [];
        try {
                let mod = this.injector.get('DropDownsCheckBoxSelection');
                if(this.injectedModules.indexOf(mod) === -1) {
                    this.injectedModules.push(mod)
                }
            } catch { }

        this.registerEvents(outputs);
        this.addTwoWay.call(this, twoWays);
        setValue('currentInstance', this, this.viewContainerRef);
        this.formContext  = new FormBase();
        this.formCompContext  = new ComponentBase();
    }
/**
 * @param {?} registerFunction
 * @return {?}
 */
public registerOnChange(registerFunction: (_: any) => void): void {
    }
/**
 * @param {?} registerFunction
 * @return {?}
 */
public registerOnTouched(registerFunction: () => void): void {
    }
/**
 * @param {?} value
 * @return {?}
 */
public writeValue(value: any): void {
    }
/**
 * @param {?} disabled
 * @return {?}
 */
public setDisabledState(disabled: boolean): void {
    }
/**
 * @return {?}
 */
public ngOnInit() {
        this.formCompContext.ngOnInit(this);
    }
/**
 * @return {?}
 */
public ngAfterViewInit(): void {
        this.formContext.ngAfterViewInit(this);
    }
/**
 * @return {?}
 */
public ngOnDestroy(): void {
        this.formCompContext.ngOnDestroy(this);
    }
/**
 * @return {?}
 */
public ngAfterContentChecked(): void {
        
        this.formCompContext.ngAfterContentChecked(this);
    }
public registerEvents: (eventList: string[]) => void;
public addTwoWay: (propList: string[]) => void;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ejs-multiselect',
    inputs: inputs,
    outputs: outputs,
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MultiSelectComponent),
            multi: true
        }
    ],
    queries: {

    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: ViewContainerRef, },
{type: Injector, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'footerTemplate': [{ type: ContentChild, args: ['footerTemplate', ] },],
'headerTemplate': [{ type: ContentChild, args: ['headerTemplate', ] },],
'valueTemplate': [{ type: ContentChild, args: ['valueTemplate', ] },],
'itemTemplate': [{ type: ContentChild, args: ['itemTemplate', ] },],
'noRecordsTemplate': [{ type: ContentChild, args: ['noRecordsTemplate', ] },],
'actionFailureTemplate': [{ type: ContentChild, args: ['actionFailureTemplate', ] },],
};
}

function MultiSelectComponent_tsickle_Closure_declarations() {
/** @type {?} */
MultiSelectComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MultiSelectComponent.ctorParameters;
/** @type {?} */
MultiSelectComponent.propDecorators;
/** @type {?} */
MultiSelectComponent.prototype.formCompContext;
/** @type {?} */
MultiSelectComponent.prototype.formContext;
/** @type {?} */
MultiSelectComponent.prototype.tagObjects;
/** @type {?} */
MultiSelectComponent.prototype.valueChange;
/**
 * Accepts the template design and assigns it to the footer container of the popup list. 
 * > For more details about the available template options refer to [`Template`](../../multi-select/templates) documentation.
 * \@default null
 * @type {?}
 */
MultiSelectComponent.prototype.footerTemplate;
/**
 * Accepts the template design and assigns it to the header container of the popup list. 
 * > For more details about the available template options refer to [`Template`](../../multi-select/templates) documentation.
 * \@default null
 * @type {?}
 */
MultiSelectComponent.prototype.headerTemplate;
/**
 * Accepts the template design and assigns it to the selected list item in the input element of the component. 
 * For more details about the available template options refer to 
 * [`Template`](../../multi-select/templates) documentation.
 * 
 * We have built-in `template engine`
 * which provides options to compile template string into a executable function.
 * For EX: We have expression evolution as like ES6 expression string literals.     
 * \@default null
 * @type {?}
 */
MultiSelectComponent.prototype.valueTemplate;
/**
 * Accepts the template design and assigns it to each list item present in the popup. 
 * > For more details about the available template options refer to [`Template`](../../multi-select/templates) documentation.
 * 
 * We have built-in `template engine`
 * which provides options to compile template string into a executable function.
 * For EX: We have expression evolution as like ES6 expression string literals.     
 * \@default null
 * @type {?}
 */
MultiSelectComponent.prototype.itemTemplate;
/** @type {?} */
MultiSelectComponent.prototype.noRecordsTemplate;
/** @type {?} */
MultiSelectComponent.prototype.actionFailureTemplate;
/** @type {?} */
MultiSelectComponent.prototype.skipFromEvent;
/** @type {?} */
MultiSelectComponent.prototype.registerEvents;
/** @type {?} */
MultiSelectComponent.prototype.addTwoWay;
/** @type {?} */
MultiSelectComponent.prototype.ngEle;
/** @type {?} */
MultiSelectComponent.prototype.srenderer;
/** @type {?} */
MultiSelectComponent.prototype.viewContainerRef;
/** @type {?} */
MultiSelectComponent.prototype.injector;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
